import { useQueryClient } from "@tanstack/react-query";
import type { User } from "oidc-client-ts";
import { useEffect, useRef } from "react";
import { useAuth } from "react-oidc-context";
import { isTokenExpired } from "./session.ts";

export const RefetchQueriesOnTokenRenewal = () => {
  const auth = useAuth();
  const queryClient = useQueryClient();
  const previousUserRef = useRef<User | null | undefined>(undefined);

  useEffect(() => {
    const previousUser = previousUserRef.current;
    previousUserRef.current = auth.user;
    const token = auth.user?.id_token;
    if (!token || token === previousUser?.id_token) {
      return;
    }
    // Refetch only when the session recovered from an expired id token
    if (!previousUser || !isTokenExpired(previousUser)) {
      return;
    }
    void queryClient.invalidateQueries({
      predicate: (query) => query.state.status === "error",
    });
  }, [auth.user, queryClient]);

  return null;
};
